import React from 'react'
import { useTranslation } from '@amusnet/translations/react'
import { useUltraPlayStore, useSoundStore } from '@stores'
import { UltraPlayModalButton } from '@components'
import { SOUNDS } from '@constants/sounds'
import closeButtonSvg from '@assets/close-button.svg'
import warningSvg from '@assets/ultra-play/ultra-play-warning.svg'
import { ultraPlayAnalytics } from './ultraPlayAnalytics'

// Centered modal shown when the player's balance can no longer cover the selected bet — at play
// time, or when the running session stops out of funds. Closing it (X or OK) only dismisses the
// modal; the session stays paused so the player can top up or change the bet and resume.
const UltraPlayInsufficientBalanceModal: React.FC = () => {
    const { t } = useTranslation()
    const setShowInsufficientBalance = useUltraPlayStore((s) => s.setShowInsufficientBalance)
    const playEngineSound = useSoundStore((s) => s.playEngineSound)

    // Same close cue as the main Ultra Play modal / in-game menus, for a consistent "dismiss" sound.
    const handleClose = () => {
        ultraPlayAnalytics.insufficientBalanceDismissed()
        playEngineSound(SOUNDS.HIDE_DENOMINATIONS)
        setShowInsufficientBalance(false)
    }

    return (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30">
            {/* Gold gradient border (2px) around the modal — drawn as a padding wrapper so it follows
                the rounded corners (border-image can't be rounded). */}
            <div className="w-[768px] rounded-[10px] p-0.5 bg-ultra-modal-border shadow-[0px_10px_10px_0px_#00000099]">
                <div className="relative w-full h-full flex flex-col items-center justify-center p-5 text-center rounded-[8px] bg-ultra-surface">
                    <button onClick={handleClose} className="absolute top-5 right-5" aria-label="Close">
                        <img src={closeButtonSvg} className="w-[58px] h-[58px]" alt="" />
                    </button>

                    <img src={warningSvg} alt="" className="w-20 h-20 mb-10" />

                    <h2 className="text-white font-black text-[40px] leading-none mb-[30px]">
                        {t('gameui.insufficientBalance')}
                    </h2>

                    <p className="text-white font-normal text-[32px] leading-[normal] mb-10 max-w-[560px]">
                        {t('gameui.ultraplay.insufficentFunds')}
                    </p>

                    <UltraPlayModalButton
                        id="ultra-play-insufficient-balance-ok"
                        text={t('common.ok')}
                        onClick={handleClose}
                    />
                </div>
            </div>
        </div>
    )
}

export default UltraPlayInsufficientBalanceModal
